export const ErrorLogService = Object.freeze({
  LogException: function(ex) {
    //TODO: Log to Stackify if possible
    console.warn("Log of error:\n" + ex);  
  },

    /**
     * Logs the error and returns the error message from an API error.
     *
     * @param {*} error
     * @returns string | undefined
     */
    LogAndGetErrorMessage(error) {
        this.LogException(error);
        return this.GetAxiosErrorMessage(error);
    },

    /**
     * Gets the error message from an API result.
     * @see https://github.com/axios/axios#handling-errors
     * @param {*} error
     * @returns string | undefined
     */
    GetAxiosErrorMessage(error) {
        if (typeof error === "string") {
            return error;
        }
        if (error) {
            if (error.response && error.response.data && error.response.data.Message) {
                return error.response.data.Message;
            } else {
                return error.message;
            }
        }
        return undefined;
    },
});
